import ErrorIcon from '@mui/icons-material/Error';

export default ErrorIcon;
